import { useContext } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { MoreHoriz, PeopleOutlined, WarningAmberOutlined } from '@mui/icons-material'
import SensorsOutlinedIcon from '@mui/icons-material/SensorsOutlined'
import { Badge, BottomNavigation, BottomNavigationAction, Paper, useTheme } from '@mui/material'

import { DashboardContext } from '../../providers/dashboard-provider'
import { NavContext } from '../../providers/nav-provider'

import useStyles from './index.styles'
import MoreMenu from './more-menu'

const BottomNavigationMenu = () => {
  const classes = useStyles
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()
  const { activeAlerts, selectedFolderId: folderId } = useContext(DashboardContext)
  const dashboardTabFromPath = location.pathname.match(/^\/dashboard\/\d+\/(devices|alerts|contacts|order-history)/)?.[1]
  const selectedTabValue = dashboardTabFromPath === 'devices' ? 'dashboard' : (dashboardTabFromPath ?? '')
  const { moreMenuOpen: toggleMoreDrawer, setMoreMenuOpen: setToggleMoreDrawer } = useContext(NavContext)

  return (
    <>
      <Paper elevation={0} sx={classes.navBarPaper(theme, toggleMoreDrawer)}>
        <BottomNavigation
          showLabels={true}
          value={toggleMoreDrawer ? 'more' : selectedTabValue}
          onChange={(_, newValue) => {
            if (newValue !== 'more') {
              setToggleMoreDrawer(false)
              const nextPath =
                newValue === 'dashboard'
                  ? folderId
                    ? `/dashboard/${folderId}/devices`
                    : '/dashboard'
                  : folderId
                    ? `/dashboard/${folderId}/${newValue}`
                    : '/dashboard'
              navigate(nextPath)
            } else {
              setToggleMoreDrawer(true)
            }
          }}
          sx={classes.nav}
        >
          <BottomNavigationAction
            label="Devices"
            icon={<SensorsOutlinedIcon sx={{ color: selectedTabValue === 'dashboard' && !toggleMoreDrawer ? 'text.primary' : 'text.secondary' }} />}
            value="dashboard"
            sx={classes.navAction}
          />

          <BottomNavigationAction
            label="Alerts"
            icon={
              <Badge color="error" variant="dot" invisible={activeAlerts.length === 0} overlap="circular" sx={classes.badge}>
                <WarningAmberOutlined
                  sx={{ color: selectedTabValue === 'alerts' && !toggleMoreDrawer ? 'text.primary' : 'text.secondary' }}
                  data-testid="alerts-icon"
                />
              </Badge>
            }
            value="alerts"
            sx={classes.navAction}
          />

          <BottomNavigationAction
            label="Contacts"
            icon={<PeopleOutlined sx={{ color: selectedTabValue === 'contacts' && !toggleMoreDrawer ? 'text.primary' : 'text.secondary' }} />}
            value="contacts"
            sx={classes.navAction}
          />

          <BottomNavigationAction
            label="More"
            icon={<MoreHoriz sx={{ color: toggleMoreDrawer ? 'text.primary' : 'text.secondary' }} />}
            value="more"
            sx={classes.navAction}
          />
        </BottomNavigation>
      </Paper>

      <MoreMenu open={toggleMoreDrawer} onClose={() => setToggleMoreDrawer(false)} />
    </>
  )
}

export default BottomNavigationMenu
